import { CopyButton } from '@/components/ui/copy-button';
import { toast } from 'sonner';
import type { WalletToken } from '@/hooks/useTokenBalances';

interface DepositTabProps {
  walletAddress: string;
  selectedToken: WalletToken | null;
}

export const DepositTab = ({ walletAddress, selectedToken }: DepositTabProps) => {
  return (
    <div className="flex flex-col space-y-4">
      {/* Network Badge */}
      <div className="flex items-center justify-center gap-1.5">
        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
        <span className="text-xs text-muted-foreground">Solana Mainnet</span>
      </div>

      <div className="rounded-lg border border-border bg-muted/50 p-4 text-center">
        {selectedToken === null ? (
          <>
            <p className="text-sm text-muted-foreground mb-2">
              Send SOL to your wallet address above
            </p>
            <p className="text-xs text-muted-foreground">
              Make sure to only send SOL on Solana network
            </p>
          </>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mb-2">
              Send {selectedToken.symbol} to your wallet address above. All Solana tokens share the same receiving address.
            </p>
            <p className="text-xs text-muted-foreground">
              Make sure to only send tokens on the Solana network
            </p>
          </>
        )}
      </div>

      <CopyButton
        value={walletAddress}
        className="w-full"
        variant="outline"
        label="Copy Address"
        copiedLabel="Address Copied!"
        onCopy={() => toast.success('Address copied to clipboard')}
      />
    </div>
  );
};
